type GTagEvent = {
    action: string;
    category: string;
    label: string;
    value?: number;
};

declare global {
    interface Window {
        gtag: any;
        fbq: any;
    }
}

export const gaevent = ({ action, category, label, value }: GTagEvent): void => {
    window.gtag("event", action, {
        event_category: category,
        event_label: label,
        value,
    });
};